import { api } from '../utils/request'

export const hotelBooking = async (data) => {
    const resp = await api({
        endpoint: '/hotelBooking',
        method: 'POST',
        data,
    })
    return resp
}

export const getHotels = async (query) => {
    const resp = await api({
        endpoint: '/hotel',
        method: 'GET',
        query
    })
    return resp
}

export const getHotelById = async (id) => {
    const resp = await api({
        endpoint: `/hotel/${id}`,
        method: 'GET',

    })
    return resp
}

export const getAminites = async (query) => {
    const resp = await api({
        endpoint: '/amenities',
        method: 'GET',
        query
    })
    return resp
}

/**
 * Fetches all hotel types from the backend
 * Used for populating the hotel type filter dropdown
 * @returns {Promise} - Response containing hotel types array
 */
export const getHotelTypes = async () => {
    const resp = await api({
        endpoint: '/hotelType',
        method: 'GET',
    })
    return resp
}